import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle } from 'lucide-react';

interface AccountLockoutWarningProps {
  failedAttempts: number;
  maxAttempts?: number;
}

export function AccountLockoutWarning({ failedAttempts, maxAttempts = 5 }: AccountLockoutWarningProps) {
  if (failedAttempts < 3) return null;

  const remainingAttempts = maxAttempts - failedAttempts;
  const isLastAttempt = remainingAttempts === 1;

  return (
    <Alert variant={isLastAttempt ? "destructive" : "default"} className="mb-4">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Warning</AlertTitle>
      <AlertDescription>
        {isLastAttempt ? (
          <strong>Last attempt remaining!</strong>
        ) : (
          <>You have {remainingAttempts} attempt(s) remaining before your account is locked for 30 minutes.</>
        )}
      </AlertDescription>
    </Alert>
  );
}
